var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useCallback, useEffect, useState } from "react";
import { getConfig, getPages } from "../../apis/api";
import { Page } from "./Page";
import { useNavigate, useParams } from "react-router-dom";
import { toSlug } from "../../util/theme";
import { PageNotFound } from "../../components/PageNotFound";
export const PageContainer = () => {
    const [pages, setPages] = useState([]);
    const [page, setPage] = useState();
    const { slug } = useParams();
    const navigate = useNavigate();
    const [config, setConfig] = useState();
    // Função para buscar a configuração
    const fetchConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getConfig();
        setConfig(response);
    }), []);
    const fetchPages = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getPages();
        setPages(response);
    }), []);
    useEffect(() => {
        !!pages.length || fetchPages();
        !!config || fetchConfig();
        const page = pages.find((page) => toSlug(page.Titulo) === slug);
        setPage(page);
    }, [fetchPages, pages, slug, fetchConfig, config]);
    const navegatePage = useCallback((page) => {
        navigate("/" + toSlug(page.Titulo));
    }, [navigate]);
    if (!page) {
        return createElement(PageNotFound);
    }
    else {
        return createElement(Page, { page, pages, navegatePage });
    }
};
